export default __webpack_public_path__ + "static/media/Arrow.c7ffe06d.svg";